<template>
  <div class="row" v-if="show">
    <div class="col-12 d-flex">
      <div class="me-3">
        <Avatar :user="student"></Avatar>
      </div>
      <div class="w-100">
        <div class="mb-2">
          <textarea
            class="form-control reply--input"
            v-model="body"
            :placeholder="$t('Reply')"
            rows="1"
            @input="autosize"
            ref="autosize"
          ></textarea>
        </div>
        <div class="d-flex justify-content-between mb-3">
          <div>
            <button
              v-if="!image && isAdmin"
              @click="initiateAddImage"
              class="btn btn-link text-secondary btn-sm me-1"
            >
              <i class="far fa-image"></i>
            </button>
            <div>
              <img v-if="image" :src="imgUrl" alt="" class="img-fluid" style="max-width: 200px;">
              <input ref="file" @change="fileChanged" class="d-none" type="file" accept="image/png, image/gif, image/jpeg" />
            </div>
          </div>
          <div>
            <button
              @click.prevent="toggleReplyCreate"
              class="btn btn-outline-secondary btn-sm"
            >
              {{ 'Cancel' | translate }}
            </button>
            <button
              @click.prevent="addReply"
              class="btn btn-primary btn-sm"
              :class="{ disabled: notValid }"
              :disabled="notValid"
            >
              {{ 'Reply' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '~/player/components/Avatar'
import _ from 'lodash'

export default {
  props: ['show', 'comment', 'reply'],
  data() {
    return {
      body: _.get(this, 'reply.ownable.name')
        ? `@${_.get(this, 'reply.ownable.name')} `
        : '',
      image: '',
    }
  },
  components: {
    Avatar,
  },
  methods: {
    fileChanged() {
      this.image = this.$refs['file'].files[0]
    },
    initiateAddImage() {
      this.$refs['file'].click()
    },
    toggleReplyCreate() {
      this.$emit('toggleReplyCreate')
      this.image = null
      this.body = ''
    },
    addReply() {
      let withFile = this.image ? true : false

      let data = {
        body: this.body,
      }

      if (withFile) {
        data = new FormData()
        data.append('body', this.body)
        data.append('image', this.image)
      }

      return this.$api.replies
        .store(this.comment.id, data, withFile)
        .then(({ data }) => {
          this.$emit('replyCreated', data)
          this.body = _.get(this, 'reply.ownable.name')
            ? `@${_.get(this, 'reply.ownable.name')} `
            : ''
          this.toggleReplyCreate()
        })
        .catch(this.handleErrors)
    },
    autosize() {
      let el = this.$refs.autosize
      el.style.height = '5px'
      el.style.height = el.scrollHeight + 'px'
    },
    handleErrors(error) {
      let status = _.get(error, 'response.status')
      if (status === 401) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Log in to set progress'),
        })
      } else if (status === 419) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Session expired'),
        })
      } else if (status === 422) {
        iziToast.warning({
          title: 'Warning',
          message: _.get(error, 'response.data.errors.body.0'),
          position: 'bottomLeft',
        })
      } else {
        console.error(error)
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
      }
    },
  },
  computed: {
    imgUrl() {
      if (this.image) {
        return URL.createObjectURL(this.image)
      }
      return null
    },
    isAdmin() {
      return this.student.type === 'App\\User'
    },
    notValid() {
      return this.body.length < 2
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    student() {
      return this.$store.state.user
    },
  },
}
</script>

<style></style>
